import { Link as ReactRouterLink } from 'react-router';
import { styled } from '@mui/material/styles';

export const Link = styled(ReactRouterLink)(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));
